import { render, staticRenderFns } from "./HeroWithBackground.vue?vue&type=template&id=3fc85dbf&scoped=true"
import script from "./HeroWithBackground.js?vue&type=script&lang=js&external"
export * from "./HeroWithBackground.js?vue&type=script&lang=js&external"
import style0 from "./HeroWithBackground.scss?vue&type=style&index=0&id=3fc85dbf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc85dbf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default,HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
